var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.hasWritePermissions || _vm.isDemoUser)?_c('div',{staticClass:"vrm-circle-icon-button",on:{"click":_vm.openAIAssistantView}},[_c('span',{staticClass:"sg-vrm-icon_149_ai-chat"})]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }